import React from "react";
import { FaTrophy } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

function TopTraders() {
  const navigate = useNavigate();

  return (
    <section
      id="top-traders-section"
      className="px-6 pt-8 bg-gradient-to-br from-white/50 to-purple-50/50"
    >
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 text-white bg-gradient-to-r from-orange-400 to-yellow-500 rounded-lg flex items-center justify-center">
            <FaTrophy className="animate-pulse" />
          </div>

          <h2 className="text-xl font-bold text-dark">Top Traders</h2>
        </div>

        <button
          onClick={() => navigate("/top-traders")}
          className="text-primary font-semibold text-sm hover:text-secondary transition-colors"
        >
          View All
        </button>
      </div>
    </section>
  );
}

export default TopTraders;
